<script setup lang="ts">
import {numberWithCommas, pointFormat} from '~/common/NumberFormater'
import { useCache } from '~/common/useCache'
import { POINT_UNIT } from '~/common/constants'
const { trackButtonClick } = useAnalytics()
const pointPopup = usePoint()
const app = useAppStore()
const selectedPackage = ref<any>('')

const handleCloseLayer = () => {
  pointPopup.hideDropsPackageLoad()
}
// ESC 키 이벤트 핸들러
const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    handleCloseLayer()
  }
}
// 충전하기 결제 페이지 이동
const handleCharge = () => {
  // 결제 페이지 이동 이벤트
  trackButtonClick(
    'click_charge_popup_button',
    '충전하기',
    {
      product_id: selectedPackage.value,
      um_idx: app.user.UM_IDX,
      date: new Date().toISOString(),
    },
    'payment',
  )

  localStorage.setItem('payBackPath', useRouter().currentRoute.value.fullPath)
  useRouter().push(`/point/charge/?package=${selectedPackage.value}`)
  handleCloseLayer()
}
const isNextButtonEnabled = computed(() => {
  return selectedPackage.value !== ''
})
onMounted(() => {
  pointPopup.getDropsPackageList()

  // ESC 키 이벤트 리스너 등록
  document.addEventListener('keydown', handleEscapeKey)
})
onUnmounted(() => {
  // 이벤트 리스너 해제
  document.removeEventListener('keydown', handleEscapeKey)
})
</script>

<template>
  <div class="layer active">
    <div class="mask" @click="handleCloseLayer"></div>
    <div class="inner">
      <section class="dropsChargeLayer fullHeight">
        <header>
          <h2>{{ POINT_UNIT }} 충전소</h2>
          <a class="layerClose" @click="handleCloseLayer">닫기</a>
        </header>
        <main>
          <div class="dropsCharge2">
            <ul>
              <li
                v-for="item in pointPopup.state.value.dropsPackageList"
                :key="item.PACKAGE_IDX"
              >
                <label class="label checkType">
                  <input
                    type="radio"
                    name="radioTest"
                    :value="item.PACKAGE_IDX"
                    @click="selectedPackage = item.PACKAGE_IDX"
                  />
                  <span class="drops-info">
                    <span class="title"
                      >{{ item.PACKAGE_NM }}
                      <!--
                      <span v-if="item.PACKAGE_BEST_TYPE === 'Y'" class="best">
                        Best
                      </span>
                      -->
                    </span>
                    <span v-if="item.PACKAGE_POINT_EVENT" class="desc">자두 {{ pointFormat(item.PACKAGE_POINT_BASE) }}개  + <span class="bonus"><span>보너스 {{ pointFormat(item.PACKAGE_POINT_EVENT) }}개 </span></span></span>
                      <span v-else class="desc">자두 {{ pointFormat(item.PACKAGE_POINT_BASE) }}개</span>
                  </span>
                  <span class="price-info">
                    <span class="price">{{ numberWithCommas(item.PACKAGE_ORI_AMOUNT) }}원</span>
                    <span class="validity">
                      유효기간 {{ item.EXPIRATION_DATE }}일
                    </span>
                  </span>
                  <!--
                  <span class="price-info">
                    <span class="current">
                      {{ numberWithCommas(item.PACKAGE_DC_AMOUNT) }}원
                    </span>
                    <span class="discount-info">
                      <span v-if="item.PACKAGE_DC_TYPE === 'Y'" class="discount"
                        >{{ item.PACKAGE_DC_PER }}%</span
                      >
                      <span
                        v-if="item.PACKAGE_DC_TYPE === 'Y'"
                        class="original"
                      >
                        {{ numberWithCommas(item.PACKAGE_ORI_AMOUNT) }}원
                      </span>
                    </span>
                  </span>
                  -->
                </label>
              </li>
            </ul>
          </div>
        </main>
        <footer>
          <div class="btnWrap">
            <a
              :class="['btnStyle', 'wide', { disable: !isNextButtonEnabled }]"
              @click="handleCharge"
            >
              충전하기
            </a>
          </div>
        </footer>
      </section>
    </div>
  </div>
</template>

<style scoped></style>
